import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  quote: string;
  product?: string;
}
export function TestimonialCard({
  initials,
  name,
  location,
  quote,
  product
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-brand-black border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col h-full hover:border-brand-green/30 transition-colors" data-id="element-319">
      <div className="flex items-center gap-4 mb-6" data-id="element-320">
        <div className="w-12 h-12 rounded-full bg-brand-dark border border-brand-green/30 flex items-center justify-center text-brand-light font-bold text-lg" data-id="element-321">
          {initials}
        </div>
        <div data-id="element-322">
          <div className="font-bold text-white" data-id="element-323">{name}</div>
          <div className="text-sm text-gray-400" data-id="element-324">{location}</div>
        </div>
      </div>

      <div className="flex gap-1 mb-4" data-id="element-325">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-326" />)}
      </div>

      <p className="text-gray-300 italic flex-grow" data-id="element-327">"{quote}"</p>

      {product && <div className="mt-6 pt-4 border-t border-gray-800 text-xs text-brand-light font-medium" data-id="element-328">
          Compró: {product}
        </div>}
    </motion.div>;
}
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Tucumán',
    quote: 'Llevaba 12 años tomando sen todas las noches. A las 3 semanas del sistema fui sola por primera vez. Lloré en el baño.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Buenos Aires',
    quote: 'El banquito y el magnesio cambiaron mi vida. No puedo creer que nadie me lo había dicho antes.'
  }, {
    initials: 'RM',
    name: 'Roxana M.',
    location: 'Córdoba',
    quote: 'El sistema de los 4 pilares lo explica todo de forma que por fin entendí qué le pasaba a mi cuerpo.'
  }];
  return <section className="py-20 bg-brand-dark" data-id="element-329">
      <div className="container mx-auto px-4" data-id="element-330">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-331">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-332" />)}
        </div>
      </div>
    </section>;
}